import styled from 'styled-components';

const Avatar = styled.div`
  width: ${props => props.width || '50px'};
  height: ${props => props.height || '50px'};
  border-radius: 50%;
  background-image: url(${props => props.image});
  background-size: cover;
  margin-right: ${props => props.marginright || '16px'};
`;

export default Avatar;
